import React from 'react'
import AutomationHerosection from './section/AutomationHerosection.js'
import AutomationEveryType from './section/AutomationEveryType.js'

const Automation = () => {
  return (
   <>
   <AutomationHerosection/>
   <AutomationEveryType/>
   </>
  )
}

export default Automation